import { motion } from 'framer-motion';

interface ToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  label?: string;
  size?: 'sm' | 'md';
}

export function Toggle({ enabled, onChange, label, size = 'md' }: ToggleProps) {
  const dims = size === 'sm'
    ? { track: 'h-5 w-9', thumb: 'h-3.5 w-3.5', translate: enabled ? 18 : 2 }
    : { track: 'h-6 w-11', thumb: 'h-4 w-4', translate: enabled ? 24 : 4 };

  return (
    <button
      role="switch"
      aria-checked={enabled}
      onClick={() => onChange(!enabled)}
      className="flex items-center gap-2.5 group"
    >
      <div
        className={`${dims.track} rounded-full relative transition-colors`}
        style={{ backgroundColor: enabled ? '#14B8A6' : 'var(--color-toggle-off)' }}
      >
        <motion.div
          className={`${dims.thumb} rounded-full bg-white absolute top-1/2`}
          animate={{ x: dims.translate }}
          style={{ y: '-50%' }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
        />
      </div>
      {label && (
        <span className={`text-sm transition-colors ${
          enabled ? 'text-primary' : 'text-muted group-hover:text-secondary'
        }`}>
          {label}
        </span>
      )}
    </button>
  );
}
